module.exports = __webpack_public_path__ + "img/fabulous.5631505d.svg";